import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { DepartmentEdit } from '@/module/Department/DepartmentEdit';
import { getDepartmentOptions } from '@/module/Department/model/DepartmentQuery';

export const Route = createFileRoute(
  '/_auth/administration/_administration/department/_department/$departmentId/_layout/edit',
)({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { departmentId } = Route.useParams();
  const { data: department } = useSuspenseQuery(getDepartmentOptions(departmentId));

  return <DepartmentEdit department={department} />;
}
